import { Row, DatePicker } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import request from '@/method/request'
import _ from 'lodash';
import "./index.scss";

const { MonthPicker } = DatePicker;

class index extends Component {
    state = {
        data: {},
        date: moment().subtract(1, 'month').format('YYYY-MM')
    }

    componentDidMount() {
        this.getData(this.state.date)
    }


    async getData(_date) {
        const res = await request(`/api/data/xiecheng/lst?year=${moment(_date).format('YYYY')}&month=${moment(_date).format('M')}`)
        let revs = [], rooms = [];
        try {
            revs = JSON.parse(res.data.revs || "[]") || [];
            rooms = JSON.parse(res.data.rooms || "[]") || [];
        } catch (error) {
            console.error('解析错误', error);
        }
        this.setState({
            data: {
                ...res.data, revs, rooms
            }
        });
    }
    render() {
        const { data, date } = this.state;
        const month = moment(date).format('M');
        return (
            <div className="performanceReview otashowctrip">
                <div className="title">
                    {/* 1.2 Ctrip Rooms Revenue & Nights Ranking - Current Year （2021 YTD）
                    携程平台集团酒店当年客房收益与间夜数（（2021）销售排名 */}
                    1.2 {data.title || `Ctrip Rooms Revenue & Nights Ranking - Current Year （1-${month} YTD）
                    携程平台集团酒店当年客房收益与间夜数（1-${month}月）销售排名`}
                    <span style={{ fontSize: 14 }}>（不含供应商数据）</span>
                    <Row className="table-month" style={{ marginTop: 10 }}>
                        <MonthPicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            defaultValue={moment(date, 'YYYY-MM')}
                            format="YYYY-MM"
                            onChange={(date, str) => {
                                this.setState({
                                    date: str,
                                    data: {},
                                    loading: true
                                });
                                this.getData(str)
                            }}
                        />
                    </Row>
                </div>
                <div className="row">
                    <div className="content">
                        <div className="title">
                            Revenue TOP 20 按收益排名前20
                    </div>
                        {(data.revs || [])
                            .map((x, i) => {
                                return (
                                    <div className="item" key={x}>
                                        <div>{i + 1}</div>
                                        <div>
                                            {x}
                                        </div>
                                    </div>
                                )
                            })}
                    </div>
                    <div className="content">
                        <div className="title">
                            Room Nights TOP 20 按间夜排名前20
                    </div>
                        {(data.rooms || []).map((x, i) => {
                            return (
                                <div className="item" key={x}>
                                    <div>{i + 1}</div>
                                    <div>
                                        {x}
                                    </div>
                                </div>
                            )
                        })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/OTAChannel/1.2/index.js